import React from "react";
import { cn } from "../../utils";

export function WaitFilledIcon({ className, width, height }) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("tbk-min-w-0 tbk-shrink-0", className)}
      role="presentation"
      aria-hidden="true"
    >
      <rect width="24" height="24" rx="12" fill="white" />
      <path
        d="M8.25 7.2H7V6H17V7.2H15.75V8.4C15.75 9.369 15.24 10.149 14.5975 10.7862C14.1581 11.2218 13.6237 11.6232 13.0819 12C13.6237 12.3768 14.1581 12.7782 14.5975 13.2138C15.24 13.851 15.75 14.631 15.75 15.6V16.8H17V18H7V16.8H8.25V15.6C8.25 14.631 8.76 13.851 9.4025 13.2138C9.84187 12.7782 10.3763 12.3768 10.9181 12C10.3763 11.6232 9.84187 11.2218 9.4025 10.7862C8.76 10.149 8.25 9.369 8.25 8.4V7.2ZM9.5 7.2V8.4C9.5 8.811 9.6625 9.201 9.98187 9.6H14.0181C14.3369 9.201 14.5 8.811 14.5 8.4V7.2H9.5ZM12 12.7332C11.3469 13.176 10.755 13.5978 10.3006 14.0484C10.1877 14.1598 10.0813 14.2772 9.98187 14.4H14.0181C13.9187 14.2772 13.8123 14.1598 13.6994 14.0484C13.245 13.5978 12.6531 13.176 12 12.7332Z"
        fill="currentColor"
      />
    </svg>
  );
}
